import { Observer } from "mobx-react";
import { UppyUploader } from "src/components";
import { AssetUppyFile } from "src/components/uploader/UppyUploader";
import { AssetResizing, AssetResizingFormat, AssetResizingRegion } from "src/generated/graphqlTypes";

const allowedFileTypes = ["image/gif", "image/jpeg", "image/png", "video/mp4", "video/quicktime"];

export type ImageEditorProps = { newElement: (file: AssetUppyFile) => Promise<void>; compact?: boolean };

export function JobLogImageEditor(props: ImageEditorProps) {
  const { newElement, compact = false } = props;
  async function handleOnFinish(file: AssetUppyFile) {
    await newElement(file);
  }

  const previewResizing: AssetResizing = { region: AssetResizingRegion.Full, format: AssetResizingFormat.Jpg };

  function renderForm() {
    return (
      <div data-testid="jobLogImageEditor">
        <UppyUploader
          type="DragDrop"
          allowedFileTypes={allowedFileTypes}
          onFinish={handleOnFinish}
          previewResizing={previewResizing}
          dragDropText={compact ? "" : "Drag & drop or click to upload photos"}
          dragDropWidth={compact ? 100 : "100%"}
          dragDropHeight={compact ? 100 : 96}
        />
      </div>
    );
  }

  return <Observer>{() => renderForm()}</Observer>;
}
